if (!customElements.get("recently-viewed")) {
  customElements.define(
    "recently-viewed",
    class RecentlyViewed extends HTMLElement {
      observer = undefined;

      constructor() {
        super();

        // Initialize variables
        this.productGrid = this.querySelector(".recently-viewed__product-grid");
      }

      connectedCallback() {
        this.recentlyViewed = localStorage.getItem("viewed-products")
          ? JSON.parse(localStorage.getItem("viewed-products"))
          : [];
        this.initializeRecentlyViewed(this.recentlyViewed);
        this.saveProductHandle();
      }

      saveProductHandle() {
        // Consider blocking products rendered via section rendering handleProductSwap
        
        // Get the products handle
        const productHandle = this.dataset.productHandle;

        // Check to see if the current product is already in viewedProducts
        if (this.recentlyViewed.includes(productHandle)) {
          this.recentlyViewed = this.recentlyViewed.filter(
            (handle) => handle !== productHandle
          );
        }

        // Insert handle to the beginning of the viewedProducts array
        this.recentlyViewed.unshift(productHandle);
        // If the viewed products array has more then three items then remove the last one
        if (this.recentlyViewed.length > 5) {
          this.recentlyViewed.pop();
        }
        // Set local storage item
        localStorage.setItem(
          "viewed-products",
          JSON.stringify(this.recentlyViewed)
        );
      }

      initializeRecentlyViewed(recentlyViewed) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecentlyViewed(recentlyViewed);
          },
          { rootMargin: "0px 0px 400px 0px" }
        );
        this.observer.observe(this);
      }

      loadRecentlyViewed(recentlyViewed) {
        // Check to see if the recentlyViewed array is empty
        // Loop through recentlyViewed array and get product information
        // Render product information to the DOM
        if (recentlyViewed.length > 0) {
          let hasFetchedSuccessfully = false;

          // Create an array of fetch promises
          const fetchPromises = recentlyViewed.map((productHandle) => {
            // Don't load current product
            if (productHandle === this.dataset.productHandle)
              return Promise.resolve(null);

            return fetch(
              `/products/${productHandle}?section_id=recently-viewed-card-product`
            )
              .then((response) => response.text())
              .then((text) => {
                const html = new DOMParser().parseFromString(text, "text/html");
                const cardProduct = html.querySelector(
                  ".recently-viewed__product"
                );
                return cardProduct;
              })
              .catch((e) => {
                console.error(e);
                return null;
              });
          });

          // Wait for all fetch promises to complete
          Promise.all(fetchPromises).then((results) => {
            results.forEach((cardProduct) => {
              if (cardProduct) {
                // Append the new products to the existing content
                this.productGrid.insertAdjacentHTML(
                  "beforeend",
                  cardProduct.innerHTML
                );

                // Set display to block after the first successful fetch
                if (!hasFetchedSuccessfully) {
                  hasFetchedSuccessfully = true;
                  this.style.visibility = "visible";
                }
              }
            });
          });
        }
      }
    }
  );
}
